import { api, type FiscalYear } from '../api';
import type { Dictionary } from '../i18n';
import * as Icon from './Icons';

/**
 * Brakujący rok obrotowy.
 *
 * Rok powstawał tylko raz, przy zakładaniu firmy. Rok później plan kont i dziennik otwierały się
 * na roku sprzed roku — ustawienia podatkowe z bieżącego roku do niego nie sięgały, więc ekran
 * mówił o brakujących ustawieniach, choć człowiek uzupełnił je chwilę wcześniej. Prawdziwym
 * brakiem był rok, nie ustawienia.
 */
export function FiscalYearGap({
  companyId,
  roles,
  years,
  t,
  onOpened,
}: {
  companyId: string;
  /** Role bieżącej osoby w firmie — rok otwiera ten, kto zamyka okresy. */
  roles: string[];
  years: FiscalYear[] | null;
  t: Dictionary;
  onOpened: () => void;
}) {
  if (years === null) return null;
  const today = new Date().toISOString().slice(0, 10);
  if (years.some((year) => year.startsOn <= today && year.endsOn >= today)) return null;

  const rok = new Date().getFullYear();
  // Otwarcie roku to czynność administracyjna, a nie księgowanie: właściciel robi to sam,
  // tak samo jak zamyka okresy (PeriodService.requireBookkeeper)
  const moze = roles.some((rola) => rola === 'OWNER' || rola === 'ADMIN' || rola === 'ACCOUNTANT');
  return (
    <div className="alert a-warn">
      <Icon.Warn />
      <div>
        <b>{t.periods.yearMissing(rok)}</b>
        <p>{t.periods.yearMissingHint}</p>
      </div>
      {moze && (
        <button
          type="button"
          className="btn"
          onClick={() => void api.openCurrentFiscalYear(companyId).then(onOpened)}
        >
          {t.periods.openYear(rok)}
        </button>
      )}
    </div>
  );
}
